<template>
    <div class="message-box free-message-box flex">
        <div class="content">
            <h3>
                Get acccess to all of our Pro features!
            </h3>
            <p>
                Treat your podcast to only the finest of things! Upgrade to a Pro subscription to access premium features, email support, and more!
            </p>
        </div>
        <div class="message-box-buttons flex">
            <button
                class="btn"
                @click="openUpgradeModal"
            >
                Upgrade to Pro Now
            </button>
            <a class="arrow-link" href="https://fusebox.fm/#pricing-table" target="_blank">
                Learn More <i class="far fa-long-arrow-right" />
            </a>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         *
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeModalVisible: true });
        },
    },
};

</script>
